import { marked } from "marked";

export let actionStart = (src) => src.match(/\|\|\|/)?.index;

let actionOptions = {};

export function configureActions(
    options = {
        enabledActions: {
            end: true,
        },
    },
) {
    actionOptions = options;
}

configureActions();

const ACTIONS = [
    {
        name: "chainOfReasoning",
        level: "block",
        // Here we want to match aggresively with ||| to avoid rendering anything
        // whatsover until we get the end of it. In the tokenizer we declare the true
        // regex.
        start: actionStart,
        tokenizer: function (src) {
            const rule = /(?:\|\|\|---HIDE:START;([\s\S]*?)\|\|\|---HIDE:END;)|(?:<thinking>([\s\S]*?)<\/thinking>)/;
            const match = rule.exec(src);
            if (match) {
                const token = {
                    type: "chainOfReasoning",
                    raw: match[0],
                    text: match[0].trim(),
                    tokens: [],
                };
                this.lexer.inline(token.text, token.tokens);
                return token;
            }
        },
        renderer: function () {
            // We don't need to render anything for the the chain of reasoning,just an empty string.
            return "";
        },
    },
    {
        name: "end",
        level: "inline",
        start: (str) => str.indexOf("|||---end;"),
        tokenizer: function (src) {
            const rule = "|||---end;";
            const index = src.indexOf(rule);

            // We match `|||---end;` as a single string.
            // or as a substring within a string.
            if (index > -1) {
                if (src.trim() === rule) {
                    return {
                        type: "end",
                        raw: src,
                        prefix: "",
                        suffix: "",
                    };
                } else {
                    let prefix = src.substring(0, index);
                    let suffix = src.substring(index + (rule.length + 1));
                    const token = {
                        type: "end",
                        raw: src,
                        prefix: this.lexer.inlineTokens(prefix),
                        suffix: this.lexer.inlineTokens(suffix),
                    };
                    return token;
                }
            }
        },
        renderer: function (token) {
            if (!actionOptions.enabledActions.end) {
                return "";
            }

            return `${this.parser.parseInline(token.prefix)}<span class="hidden" data-action="end" data-action-processed="false"></span>${this.parser.parseInline(token.suffix)}`;
        },
        childTokens: ["prefix", "suffix"],
    },
];

marked.use({
    breaks: true,
    gfm: true,
    silent: true,
    extensions: ACTIONS,
    renderer: {
        image() {
            return "";
        },
    },
});

export function getCookie(name) {
    let cookieValue = null;

    // With CSRF_USE_SESSIONS the CSRF secret lives in the session; the token is
    // rendered server-side into <meta name="csrf-token">. This meta token is
    // AUTHORITATIVE and must take precedence over any `csrftoken` cookie: a stale,
    // pre-sessions csrftoken cookie (set with a ~1-year expiry and NOT cleared when
    // the setting flips) would otherwise be read first and send a token that no
    // longer matches the session secret -> 403 REASON_BAD_TOKEN (BUG-841). The cookie
    // read below remains as a fallback for environments without CSRF_USE_SESSIONS.
    if (name === "csrftoken" && typeof document !== "undefined") {
        const meta = document.querySelector('meta[name="csrf-token"]');
        cookieValue = (meta && meta.getAttribute("content")) || null;
    }

    if (!cookieValue && document.cookie && document.cookie !== "") {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === name + "=") {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }

    return cookieValue;
}
